'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagCwAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "#0543A8" }),
      /* @__PURE__ */ jsx("path", { d: "M28 13.3333H0V16H28V13.3333Z", fill: "#FCC747" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.66668 8.35602L7.09926 9.49071L7.69405 7.64936L6.13053 6.50929L8.06556 6.50596L8.66668 4.66667L9.26781 6.50596L11.2028 6.50929L9.63932 7.64936L10.2341 9.49071L8.66668 8.35602Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.99993 4.76702L2.82436 5.61803L3.27046 4.23702L2.09782 3.38197L3.54909 3.37947L3.99993 2L4.45077 3.37947L5.90205 3.38197L4.72941 4.23702L5.1755 5.61803L3.99993 4.76702Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagCwAsset = forwardRef(FlagCwAsset);

export { VpFlagCwAsset as default };
